import { useCallback } from "react";
import { useTranslations } from "next-intl";
import { emailSkipReasonKey } from "@/lib/utils/emailSkipReason";

/**
 * The human sentence for a `skipReason` code, shared by every surface that
 * shows one: the sent-mails table chip, the guest-drawer badge and the detail
 * dialog's "not sent" block. One hook, so the three cannot drift the way the
 * two badge-colour maps once did.
 *
 * @returns a function — known code → its sentence; unknown, non-empty code →
 *   the generic line carrying the raw code; empty → undefined (nothing to say).
 */
export function useEmailSkipReasonLabel(): (
  code?: string | null,
) => string | undefined {
  const t = useTranslations("emailSkipReason");
  return useCallback(
    (code?: string | null) => {
      if (!code) return undefined;
      const key = emailSkipReasonKey(code);
      return key ? t(key) : t("unknown", { code });
    },
    [t],
  );
}
